export default __webpack_public_path__ + "static/media/ic_eth_40.03a12ea6.svg";